var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.061 2.91628L15.061 0.972093C15.061 0.435315 14.6406 -1.83796e-08 14.1221 -4.1043e-08L12.2442 -1.23129e-07C11.7257 -1.45792e-07 11.3052 0.435315 11.3052 0.972093L11.3052 2.91628C11.3052 3.45306 11.7257 3.88837 12.2442 3.88837L14.1221 3.88837C14.6406 3.88837 15.061 3.45306 15.061 2.91628ZM10.3663 2.91628L10.3663 0.972093C10.3663 0.435315 9.94579 -2.23594e-07 9.42731 -2.46258e-07L7.54941 -3.28344e-07C7.03093 -3.51007e-07 6.61045 0.435315 6.61045 0.972093L6.61045 2.91628C6.61045 3.45306 7.03093 3.88837 7.54941 3.88837L9.42731 3.88837C9.94579 3.88837 10.3663 3.45306 10.3663 2.91628ZM5.6715 2.91628L5.6715 0.972093C5.6715 0.435315 5.25103 -4.28809e-07 4.73255 -4.51473e-07L2.85464 -5.33558e-07C2.33616 -5.56222e-07 1.91569 0.435315 1.91569 0.972092L1.91569 2.91628C1.91569 3.45306 2.33616 3.88837 2.85464 3.88837L4.73255 3.88837C5.25103 3.88837 5.6715 3.45306 5.6715 2.91628ZM15.061 8.74884L15.061 6.80465C15.061 6.26787 14.6406 5.83256 14.1221 5.83256L12.2442 5.83256C11.7257 5.83256 11.3052 6.26787 11.3052 6.80465L11.3052 8.74884C11.3052 9.28561 11.7257 9.72093 12.2442 9.72093L14.1221 9.72093C14.6406 9.72093 15.061 9.28561 15.061 8.74884ZM10.3663 8.74884L10.3663 6.80465C10.3663 6.26787 9.94579 5.83256 9.42731 5.83256L7.54941 5.83256C7.03093 5.83256 6.61045 6.26787 6.61045 6.80465L6.61045 8.74884C6.61045 9.28561 7.03093 9.72093 7.54941 9.72093L9.42731 9.72093C9.94579 9.72093 10.3663 9.28561 10.3663 8.74884ZM5.6715 8.74884L5.6715 6.80465C5.6715 6.26787 5.25102 5.83256 4.73255 5.83256L2.85464 5.83256C2.33616 5.83256 1.91569 6.26787 1.91569 6.80465L1.91569 8.74884C1.91569 9.28561 2.33616 9.72093 2.85464 9.72093L4.73255 9.72093C5.25102 9.72093 5.6715 9.28561 5.6715 8.74884Z",
    fill: "#1E406E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.72093,
    height: 15.0233,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridHorizontal);
export default __webpack_public_path__ + "static/media/grid-horizontal.f4c714838a703fae23b6174a6533b6c3.svg";
export { ForwardRef as ReactComponent };